import { render, staticRenderFns } from "./pendingcollection.vue?vue&type=template&id=20295dd9"
import script from "./pendingcollection.vue?vue&type=script&lang=js"
export * from "./pendingcollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports